'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var InfiniteScrollTable = require('../InfiniteScrollTable/InfiniteScrollTable.js');
var utils = require('./utils.js');

var InfiniteScrollTableNoTotalCount = function (props) {
    var fetchMore = props.fetchMore, _a = props.pageSize, pageSize = _a === void 0 ? 20 : _a;
    var fetchMoreDataCallback = React.useCallback(function (pageNumber) {
        return utils.fetchMoreData(pageNumber, pageSize, fetchMore);
    }, [pageSize, fetchMore]);
    // eslint-disable-next-line react/jsx-props-no-spreading
    return React__default.createElement(InfiniteScrollTable, tslib.__assign({}, props, { fetchMore: fetchMoreDataCallback }));
};

module.exports = InfiniteScrollTableNoTotalCount;
